/*
  V2 · «Atrás» cierra la capa abierta (pedido de Boris, 11/10/2026).

  En el celular, si hay una foto ampliada, una galería o un diálogo abierto, el botón
  o gesto «atrás» tiene que cerrar esa capa y dejar al cliente en la misma página.

  Cómo funciona:
  - Al abrirse una capa se agrega una entrada al historial (pushState, misma URL).
  - «Atrás» consume esa entrada y cerramos la capa.
  - Si el cliente cierra la capa con la X, Esc o tocando afuera, retiramos la entrada
    con history.back() para no dejar entradas fantasma.

  Solo cubre capas para VER contenido, que no navegan a otra página. El menú, el carrito
  y el buscador quedan afuera a propósito: tienen enlaces que salen de la página y
  dejarían entradas fantasma en el historial.
*/
(function () {
  if (window.tmAtrasCierra) return;
  window.tmAtrasCierra = true;

  var BOTON_CERRAR = 'button[class*="close"], button[data-dg-close], button[aria-label^="Cerrar"], button[aria-label^="Close"]';

  function clicCerrar(el) {
    var boton = el.querySelector(BOTON_CERRAR);
    if (boton) { boton.click(); return true; }
    return false;
  }

  var TIPOS = [
    {
      // Fotos de trabajos (home y fichas B2B): se abren quitando el atributo hidden.
      sel: '.home-galeria__lightbox, .b2b-galeria__lightbox',
      abierta: function (el) { return !el.hidden; },
      cerrar: clicCerrar
    },
    {
      // Diálogos nativos: trabajos, galería de diseños, selector, configurador y comparación del Kit 15.
      sel: 'dialog.tg-lb, dialog.dg-dialog, dialog.ds-dialog, dialog#cfg-lightbox, dialog.tm-og__dialog',
      abierta: function (el) { return el.open; },
      cerrar: function (el) { if (!clicCerrar(el) && el.open) el.close(); }
    },
    {
      // Zoom de imágenes del producto y detalle del retiro en tienda.
      sel: 'product-modal, pickup-availability-drawer',
      abierta: function (el) { return el.hasAttribute('open'); },
      cerrar: function (el) { if (typeof el.hide === 'function') el.hide(); else el.removeAttribute('open'); }
    }
  ];
  var SELECTOR = TIPOS.map(function (t) { return t.sel; }).join(', ');

  function tipoDe(el) {
    for (var i = 0; i < TIPOS.length; i++) if (el.matches(TIPOS[i].sel)) return TIPOS[i];
    return null;
  }

  var pila = [];   // capas abiertas por orden; la última es la de arriba
  var ignorar = 0; // popstate que provocamos nosotros con history.back()

  function alAbrir(el) {
    if (pila.indexOf(el) !== -1) return;
    pila.push(el);
    try { history.pushState({ tmCapa: pila.length }, ''); } catch (error) { pila.pop(); }
  }

  function alCerrar(el) {
    var i = pila.indexOf(el);
    if (i === -1) return; // ya la cerró «atrás»: su entrada ya se consumió
    pila.splice(i, 1);
    ignorar++;
    history.back();
  }

  window.addEventListener('popstate', function () {
    if (ignorar > 0) { ignorar--; return; }
    var el = pila.pop();
    if (!el) return;
    var tipo = tipoDe(el);
    if (tipo && tipo.abierta(el)) tipo.cerrar(el);
  });

  var abiertas = new WeakMap();
  new MutationObserver(function (cambios) {
    cambios.forEach(function (cambio) {
      var el = cambio.target;
      if (el.nodeType !== 1 || !el.matches(SELECTOR)) return;
      var tipo = tipoDe(el);
      var ahora = !!tipo.abierta(el);
      if (ahora === !!abiertas.get(el)) return;
      abiertas.set(el, ahora);
      if (ahora) alAbrir(el); else alCerrar(el);
    });
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['open', 'hidden'] });
})();
